<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Users</a>
        </li>
      </ol>
    </div>
  </div>

    
  <div class="modal fade" bsModal #updateItemModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" *ngIf="user">
        <div class="modal-header">
          <h5 class="modal-title">UPDATE USER: {{user.email}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="updateItemModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>First Name</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="user.firstName" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Last Name</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="user.lastName" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Display Name</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="user.displayName" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Telephone</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="user.telephone" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <label>Options</label>
              <div class="card p-2 mb-2">
                <div class="form-group input-group-sm">
                  
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="onSwitch" [(ngModel)]="user.isOnboarded" >
                    <label class="form-check-label" for="onSwitch">Is Onboarded</label>
                  </div>
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="acceptedSwitch" [(ngModel)]="user.acceptedTerms" >
                    <label class="form-check-label" for="acceptedSwitch">Accepted Terms</label>
                  </div>
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="ownerSwitch" [(ngModel)]="user.isOwner" >
                    <label class="form-check-label" for="ownerSwitch">Is Owner</label>
                  </div>               
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="analysisSwitch" [(ngModel)]="user.disableAnalysis" >
                    <label class="form-check-label" for="analysisSwitch">Disable Analysis</label>
                  </div>
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="fireOperatorSwitch" [(ngModel)]="user.isFireOperator" >
                    <label class="form-check-label" for="fireOperatorSwitch">Is Fire Operator</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                
                <label>Primary Customer</label>
                <select [(ngModel)]="user.customerId" class="form-select">
                  <option *ngFor="let c of customers" [value]="c.customerId">{{c.customerName}}</option>
                </select>

                <label>Dashboard Category Filter (comma seperated list)</label>
                <input type="text" [(ngModel)]="user.dashboardCategoryFilter" class="form-control"/>

                <label>Site Type Category Filter (comma seperated list)</label>
                <input type="text" [(ngModel)]="user.siteCategoryFilter" class="form-control"/>
              </div>
              
            </div>
            <div class="col-sm-12">
              <label>Mapped Customers</label>
              <tag-input [(ngModel)]="user.mappedCustomers" 
                    theme="bootstrap"
                    [onlyFromAutocomplete]="true"
                    [identifyBy]="'customerId'"
                    [displayBy]="'customerName'"
                    [autocompleteItems]="customers"
                    [placeholder]="'Add Customers'">
                    <!--(onRemove)="onRemoveMappedCustomer(user, $event)"
                    (onAdd)="onAddMappedCustomer(user, $event)">-->
                <tag-input-dropdown
                  [autocompleteItems]="customers"
                  [showDropdownIfEmpty]="true"
                  [appendToBody]="false"
                  [identifyBy]="'customerId'"
                  [displayBy]="'customerName'"
                  [zIndex]="10000">
                </tag-input-dropdown>    
              </tag-input>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="updateItemModal.hide()" class="btn btn-white">Cancel</button>
          <button (click)="updateUser();updateItemModal.hide()" class="btn btn-white">Save</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" bsModal #addItemModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" *ngIf="user">
        <div class="modal-header">
          <h5 class="modal-title">CREATE USER</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addItemModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Display Name</label>
                <div class="input-group m-b" >
                    <input type="text" [(ngModel)]="newuser.displayName" class="form-control" [ngClass]="{'is-invalid': !newuser.displayName, 'is-valid':newuser.displayName}"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Email Address</label>
                <div class="input-group m-b">
                    <!-- show is-valid if they have entered a valid email address -->
                    <input type="text" [(ngModel)]="newuser.email" class="form-control" [ngClass]="{'is-invalid': !isValidEmail(newuser.email), 'is-valid':isValidEmail(newuser.email)}"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                <label>Telephone</label>
                <div class="input-group m-b">
                    <input type="text" [(ngModel)]="newuser.telephone" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group input-group-sm">
                
                <label>Customer</label>
                <select [(ngModel)]="newuser.customerId" class="form-select" [ngClass]="{'is-invalid': !newuser.customerId, 'is-valid': newuser.customerId}">
                  <option *ngFor="let c of customers" [value]="c.customerId">{{c.customerName}}</option>
                </select>

                <label>Dashboard Category Filter (comma seperated list)</label>
                <input type="text" [(ngModel)]="newuser.dashboardCategoryFilter" class="form-control"/>

                <label>Site Type Category Filter (comma seperated list)</label>
                <input type="text" [(ngModel)]="newuser.siteCategoryFilter" class="form-control"/>
              </div>              
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="addItemModal.hide()" class="btn btn-white">Cancel</button>
          <button (click)="addUser();addItemModal.hide()" class="btn btn-white" [disabled]="!canAddUser()">Add User</button>
        </div>
      </div>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="card mt-2">
          <div class="card-body">
            <div class="d-flex fw-bold small mb-3">
              <button class="btn btn-outline-default" (click)="newuser={};addItemModal.show()"><i class="fa fa-plus"></i> Add User</button>
              <span class="flex-grow-1">
                <input type="text" [(ngModel)]="userFilter" class="form-control" (keyup.enter)="filterCustomer(userFilter,customer)"/>
              </span>                    
              <span>
                <div class="btn-group form-group float-right filter-button" dropdown>
                  <button id="button-basic" dropdownToggle type="button" class="btn btn-outline-default dropdown-toggle" aria-controls="dropdown-basic">
                  Customer : {{customer == null ? "Not Set" : customer.customerName}} 
                  </button>
                  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                    <li role="menuitem"><a class="dropdown-item" (click)="clearFilterCustomer()">Clear</a></li>  
                    <li role="menuitem" *ngFor="let customer of customers"><a class="dropdown-item" (click)="filterCustomer(userFilter, customer)">{{customer.customerName}}</a></li>
                  </ul>
                </div>
              </span>
            </div>
            <table class="table table-striped"> 
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Email</th>
                  <th scope="col" class="d-none d-xl-table-cell">Display Name</th>
                  <th scope="col" class="d-none d-lg-table-cell">Telephone</th>
                  <th scope="col" class="d-none d-xl-table-cell">Onboarded</th>
                  <th scope="col" class="d-none d-lg-table-cell">Owner</th>
                  <th scope="col" class="d-none d-lg-table-cell">Fire Operator</th>
                  
                  <th scope="col" class="d-none d-xl-table-cell">Accepted Terms</th>
                  <th scope="col">Customer</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="userTableService.loading">
                  <td colspan="10"><div class="spinner-border"></div></td>
                </tr>
                <tr *ngFor="let list of remoteData | async">
                  <td>{{list.userId}}</td>
                  <td>{{list.email}}</td>
                  <td class="d-none d-xl-table-cell ">{{list.displayName}}</td>
                  <td class="d-none d-lg-table-cell ">{{list.telephone}}</td>
                  <td class="d-none d-xl-table-cell text-center"><i class="fa fa-check" *ngIf="list.isOnboarded" title="Onboarded"></i></td>
                  <td class="d-none d-lg-table-cell text-center"><i class="fa fa-check" *ngIf="list.isOwner" title="Is Account Owner"></i></td>
                  <td class="d-none d-lg-table-cell text-center"><i class="fa fa-check" *ngIf="list.isFireOperator" title="Is Fire Operator"></i></td>
                  <td class="d-none d-xl-table-cell text-center"><i class="fa fa-check" *ngIf="list.acceptedTerms" title="Has Accepted Terms and Conditions"></i></td>
                  <td>{{getCustomerName(list.customerId)}}</td>
                  <td>
                    <a class="btn btn-outline-default" (click)="clearCache(list)"><i class="fa fa-memory"></i> Clear Cache</a>
                    <!-- edit template -->
                    <a class="btn btn-outline-default ml-2" (click)="user=list;updateItemModal.show()"><i class="fa fa-pencil"></i></a>
                    <!-- delete -->
                    <a class="btn btn-outline-danger ml-2" (click)="removeUser(list)"><i class="fa fa-trash"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>  
        </div>
      </div>
    </div>
  </div>  

  